import {i18n} from '@yourcoach/i18n';

import type {Props as AlertProps} from '../../../components/alert/components/Alert/types';
import type {Nullable} from '../../../utils/utility-types';

import {alert} from '../../../components/alert';
import {COMMAND} from '../../../services/entity-action/utils';
import {Checkbox} from '../../../uikit/Checkbox';
import {Text} from '../../../uikit/Text';
import * as S from './styles';

type Option = {
  id: ResultId;
  label: string;
};

type ResultId = 'client_not_show' | 'completed_successfully';

export const showSessionResultAlert = () => {
  let checkedId: Nullable<ResultId> = null;

  const options: Option[] = [
    {
      id: 'completed_successfully',
      label: i18n.t('shared:completed_successfully'),
    },
    {
      id: 'client_not_show',
      label: i18n.t('shared:client_did_not_show'),
    },
  ];

  const onCheckboxClick = (id: ResultId) => {
    checkedId = id;
    alert.update(getAlertProps({checkedId, renderMessage}));
  };

  const renderMessage = () => (
    <S.Container>
      {options.map(({id, label}) => (
        <S.Row>
          <Checkbox
            checked={checkedId === id}
            onClick={() => onCheckboxClick(id)}
          />
          <Text>{label}</Text>
        </S.Row>
      ))}
    </S.Container>
  );

  return alert.show(getAlertProps({checkedId, renderMessage}));
};

const getAlertProps = (config: {
  checkedId: Nullable<ResultId>;
  renderMessage: AlertProps['renderMessage'];
}): AlertProps<ResultId | typeof COMMAND.CANCEL> => {
  return {
    buttons: [
      {
        isDisabled: !config.checkedId,
        label: i18n.t('shared:send'),
        onAwaitableClick: resolve => resolve(config.checkedId!),
        scheme: 'primary',
      },
    ],
    isDismissible: true,
    onDismiss: () => COMMAND.CANCEL,
    renderMessage: config.renderMessage,
    title: i18n.t('shared:how_was_the_session'),
  };
};
